<template>
  <div v-if="showFilter">
    <div class="filter-header">
      {{ trans('filters.activity') }}
    </div>
    <div class="filter-row">
      <div
        class="filter-component"
      >
        <multi-select-component
          id="lecturers_multi_select"
          v-model="filter.lecturers"
          type="lecturer"
          :include="multiSelectInclude"
          :search-at-mounted="true"
          track-by="name"
          :placeholder="trans_choice('core.lecturers', 2)"
        />
      </div>
      <div
        v-if="type === 'course'"
        class="filter-component"
      >
        <multi-select-component
          id="groups_multi_select"
          v-model="filter.groups"
          type="group"
          :include="multiSelectInclude"
          :query-options="{ 'withTerm': 1 }"
          :search-at-mounted="true"
          track-by="id"
          :placeholder="trans_choice('core.groups', 2)"
        />
      </div>
      <div
        v-if="type === 'group'"
        class="filter-component"
      >
        <multi-select-component
          id="course_multi_select"
          v-model="filter.courses"
          type="course"
          :include="multiSelectInclude"
          :search-at-mounted="true"
          :query-options="{ 'onlyTitle': 1 }"
          track-by="name"
          :placeholder="trans_choice('core.courses', 2)"
        />
      </div>
      <div class="filter-component">
        <date-picker-component
          id="single_subscriptions_startdate"
          v-model="filter.startdate"
          :placeholder="trans('dates.from')"
        />
      </div>
      <div class="filter-component">
        <date-picker-component
          id="single_subscriptions_enddate"
          v-model="filter.enddate"
          :placeholder="trans('dates.until')"
        />
      </div>
      <div class="filter-component">
        <multi-select-with-options-component
          id="attendance-filter"
          :value="filter.attendance"
          :options="attendanceOptions"
          :max-selected-options="1"
          :placeholder="trans('core.attendance')"
          track-by="id"
          @input="updateAttendance"
        />
      </div>
      <div class="filter-component">
        <button
          style="width: 100% !important;"
          :disabled="isExporting"
          class="btn btn-default pull-right"
          @click="exportSubscriptions"
        >
          <em class="fa fa-envelope-o" /><span class="hide-small-devs"> {{ trans('core.export') }}</span>
        </button>
      </div>
    </div>
    <div class="filter-header">
      {{ trans('filters.student') }}
    </div>
    <div class="filter-row">
      <div
        v-if="type === 'course'"
        class="filter-component"
      >
        <multi-select-component
          id="groups_multi_select"
          v-model="filter.studentGroups"
          type="group"
          :include="multiSelectInclude"
          :query-options="{ 'withTerm': 1 }"
          :search-at-mounted="true"
          track-by="id"
          :placeholder="trans_choice('core.groups', 2)"
        />
      </div>
      <div class="filter-component">
        <multi-select-with-options-component
          id="status-filter"
          :value="filter.status"
          :options="statusOptions"
          :max-selected-options="1"
          :placeholder="trans('core.status')"
          track-by="id"
          @input="updateStatus"
        />
      </div>
    </div>

    <modal
      v-if="displayModal"
      :open="displayModal"
      :title="trans('core.export')"
      style="text-align:left; z-index: 9999999999"
      @close="displayModal = false"
    >
      <p> {{ trans('mail.export_sent') }} </p>

      <button
        type="button"
        class="btn btn-default pull-right"
        @click="displayModal = false"
      >
        {{ trans('core.close') }}
      </button>
      <br style="clear:both">
    </modal>
  </div>
</template>

<script>
import DatePickerComponent from '@/employees/components/FormComponents/DatePickerComponent'
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import MultiSelectWithOptionsComponent from '@/employees/components/FormComponents/MultiSelectWithOptionsComponent'
import Modal from '@/employees/AttendanceList/components/Modal'
import Multiselect from 'vue-multiselect'
import toast from '../../../services/toast'
import { mapState } from 'vuex'
import { uniqueFilter } from '@/helpers'

export default {
  name: 'AttendanceMatrixFilter',

  components: { MultiSelectWithOptionsComponent, MultiSelectComponent, DatePickerComponent, Modal, Multiselect },

  props: {
    type: {
      required: true,
      type: String,
      default: null,
    },
    modelId: {
      required: true,
      type: String,
      default: null,
    },
    value: {
      required: true,
      type: Object,
    },
    showFilter: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      displayModal: false,
      isExporting: false,
      filter: {
        lecturers: [],
        groups: [],
        courses: [],
        studentGroups: [],
        startdate: null,
        enddate: null,
        attendance: [],
        status: [],
      },
    }
  },

  computed: {
    ...mapState({
      storeLecturers (state) {
        return Object.values(state.lecturers.lecturers)
      },
      storeGroups (state) {
        return Object.values(state.groups.groups)
      },
      storeCourses (state) {
        return Object.values(state.courses.courses)
      },
    }),
    attendanceOptions () {
      return [
        { name: this.trans('courses.attendance_registered'), id: 1 },
        { name: this.trans('courses.attendance_not_registered'), id: 0 },
      ]
    },
    statusOptions () {
      return [
        { name: this.trans('courses.has_status_at_events'), id: 1 },
        { name: this.trans('courses.has_no_status_at_events'), id: 0 },
      ]
    },
    multiSelectInclude () {
      if (this.type === 'course') {
        return { course_id: this.modelId }
      } else if (this.type === 'group') {
        return { group_id: this.modelId }
      } else {
        return {}
      }
    },
  },

  watch: {
    filter: {
      deep: true,
      handler () {
        this.filterData()

        // set the url params
        const params = new URLSearchParams(window.location.search)

        params.set('startdate', this.filter.startdate)
        params.set('enddate', this.filter.enddate)

        params.delete('lecturer')
        this.filter.lecturers.forEach(lecturer => params.append('lecturer', lecturer.id))

        params.delete('courses')
        this.filter.courses.forEach(course => params.append('courses', course.id))

        params.delete('group')
        this.filter.groups.forEach(group => params.append('group', group.id))

        params.delete('student_group')
        this.filter.studentGroups.forEach(group => params.append('student_group', group.id))

        params.delete('attendance')
        this.filter.attendance.forEach(attendance => params.append('attendance', attendance.id))

        params.delete('status')
        this.filter.status.forEach(status => params.append('status', status.id))

        window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`))
      },
    },
  },

  mounted () {
    this.setFiltersFromUrl()
    this.filterData()
  },

  methods: {
    filterData () {
      this.$emit('input', this.filter)
    },
    updateAttendance (event) {
      this.filter.attendance = event
    },
    updateStatus (event) {
      this.filter.status = event
    },

    setFiltersFromUrl () {
      const urlParams = new URLSearchParams(window.location.search)
      const FilterLecturers = []
      const FilterGroups = []
      const FilterCourses = []
      const FilterStudentGroups = []
      const FilterAttendance = []
      const FilterStatus = []

      // set endDate filter
      // If not provided we filter today to keep it backward compatible
      const endDate = urlParams.get('enddate') === 'null'
          ? null
          : (
              urlParams.get('enddate') == null
                  ? moment().format('YYYY-MM-DD')
                  : urlParams.get('enddate')
          )

      const startDate = urlParams.get('startdate')

      // foreach group form the params, try to find it in the store
      const UrlGroups = urlParams.getAll('group')
      UrlGroups.filter(uniqueFilter).forEach(UrlGroup => {
        const group = this.storeGroups.find(group => group.id == UrlGroup)
        if (group) {
          FilterGroups.push(group)
        }
      })

      // foreach group form the params, try to find it in the store
      const UrlCourses = urlParams.getAll('courses')
      UrlCourses.forEach(UrlCourse => {
        const course = this.storeCourses.find(course => course.id == UrlCourse)
        if (course) {
          FilterCourses.push(course)
        }
      })

      const UrlStudentGroups = urlParams.getAll('student_group')
      UrlStudentGroups.filter(uniqueFilter).forEach(UrlStudentGroup => {
        const studentGroup = this.storeGroups.find(group => group.id == UrlStudentGroup)
        if (studentGroup) {
          FilterStudentGroups.push(studentGroup)
        }
      })

      // foreach lecturer form the params, try to find it in the store
      const UrlLecturers = urlParams.getAll('lecturer')
      UrlLecturers.forEach(UrlLecturer => {
        const lecturer = this.storeLecturers.find(lecturer => lecturer.id == UrlLecturer)
        if (lecturer) {
          FilterLecturers.push(lecturer)
        }
      })

      // for attendance
      const urlAttendances = urlParams.getAll('attendance')
      urlAttendances.forEach(urlAttendance => {
        const att = this.attendanceOptions.find(opt => {
          return opt.id == urlAttendance
        })
        if (att) {
          FilterAttendance.push(att)
        }
      })

      // for status
      const urlStatuses = urlParams.getAll('status')
      urlStatuses.forEach(urlStatus => {
        const status = this.statusOptions.find(opt => {
          return opt.id == urlStatus
        })
        if (status) {
          FilterStatus.push(status)
        }
      })

      this.filter = {
        lecturers: FilterLecturers,
        groups: FilterGroups,
        studentGroups: FilterStudentGroups,
        courses: FilterCourses,
        startdate: startDate != null && !isNaN(Date.parse(startDate)) ? startDate : null,
        enddate: endDate != null && !isNaN(Date.parse(endDate)) ? endDate : null,
        attendance: FilterAttendance,
        status: FilterStatus,
      }
    },

    exportSubscriptions () {
      this.isExporting = true

      const queryParams = {
        startdate: this.filter.startdate,
        enddate: this.filter.enddate,
        lecturers: this.filter.lecturers.length > 0 ? this.filter.lecturers.map(lecturer => lecturer.id) : null,
        groups: this.filter.groups.length > 0 ? this.filter.groups.map(group => group.id) : null,
        courses: this.filter.courses.length > 0 ? this.filter.courses.map(course => course.id) : null,
        student_groups: this.filter.studentGroups.length > 0 ? this.filter.studentGroups.map(group => group.id) : null,
        attendance: this.filter.attendance.length > 0 ? this.filter.attendance[0].id : null,
        status: this.filter.status.length > 0 ? this.filter.status[0].id : null,
      }

      let dispatch = null
      if (this.type === 'course') {
        dispatch = this.$store.dispatch('exportCourseMatrixLessons', {
          courseId: this.modelId,
          queryParams,
        })
      } else if (this.type === 'group') {
        dispatch = this.$store.dispatch('exportGroupMatrixLessons', {
          groupId: this.modelId,
          queryParams,
        })
      } else {
        this.isExporting = false
        return
      }

      dispatch.then(() => {
        this.displayModal = true
      }).catch(() => {
        toast.error(Lang.get('errors.message.generalerror'))
      }).finally(() => {
        this.isExporting = false
      })
    },
  },
}
</script>

<style lang="scss">
.filter-header {
  font-weight: bold;
  margin-top: 5px;
}

.filter-row {
  display: flex;
  justify-content: space-between;
  gap: 5px;

  @media (max-width: 1000px) {
    flex-direction: column
  }
  @media (min-width: 999px) {
    flex-direction: row
  }
}

.filter-component {
  flex: 1;

  input:focus {
    border-color: #ccc !important;
    box-shadow: none !important;
  }

  ::placeholder {
    color: lightgrey !important;
  }
}

.multiselect__tags{
  border: 1px solid #ccc;
}

.el-input__inner {
  border: 1px solid #ccc;
}

.export{
  margin-left:0px;
}
</style>
